/*
 * @Descripttion:
 * @version:
 * @Author: wlk
 * @Date: 2023-11-28 17:02:22
 * @LastEditors: dengyao
 * @LastEditTime: 2025-09-03 18:59:16
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import registerPlugin from './plugins/index'
import store from '@/store/store'
import directive from '@/directive/index'
import registerCompoent from '@/components/index'
import { lang } from './utils'
import request from '@/service/request'
import './assets/iconfont/iconfont.css'
import '@/assets/style/common.less'
import VueWechatTitle from 'vue-wechat-title' // 动态修改title
import echarts from '@/plugins/charts'
/** 电子签名 */
import vueEsign from 'vue-esign'
/** 云眼埋点 */
import { initTrack } from 'yl-track'
import print from 'vue3-print-nb'
const app = createApp(App)
app.use(print)
const packageList = [router, store, registerCompoent, directive, VueWechatTitle, vueEsign]
packageList.forEach((p) => app.use(p))

//按需注册全局组件
registerPlugin(app)
app.config.globalProperties.$lang = lang
app.config.globalProperties.$req = request
app.config.globalProperties.$echarts = echarts

initTrack({
  pid: 'site-yoyi-mx'
})

app.provide('$echarts', echarts)
app.mount('#app')
